var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#888BAA",
    fillRule: "evenodd",
    d: "M12.255 16.03c-.488-.489-1.28-.489-1.768 0L7.935 18.58v-8.294c0-.69-.56-1.25-1.25-1.25s-1.25.56-1.25 1.25v8.294L2.884 16.03c-.488-.489-1.28-.489-1.768 0-.488.488-.488 1.28 0 1.767l4.51 4.51c.289.29.684.407 1.06.354.375.053.77-.065 1.059-.354l4.51-4.51c.488-.488.488-1.28 0-1.767zm5.328-2.894c0 .69-.56 1.25-1.25 1.25s-1.25-.56-1.25-1.25V4.842l-2.551 2.552c-.489.488-1.28.488-1.768 0-.488-.489-.488-1.28 0-1.768l4.51-4.51c.289-.289.684-.407 1.06-.354.375-.053.77.065 1.059.354l4.51 4.51c.488.488.488 1.28 0 1.768-.489.488-1.28.488-1.768 0l-2.552-2.552v8.294z",
    clipRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.16f139cd.svg";
export { ForwardRef as ReactComponent };